import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import QRCode from "react-qr-code";
import '../styles.css';

const ProfilePage = () => {
  const [pdfs, setPdfs] = useState([]);
  const [uniqueUsername, setUniqueUsername] = useState('');
  const [qrModal, setQrModal] = useState({ show: false, qrUrl: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = {
      id: localStorage.getItem('userId'),
      unique_username: localStorage.getItem('unique_username'),
    };

    if (!storedUser.id || !storedUser.unique_username) {
      navigate('/login'); // Redirect if not logged in
      return;
    }

    setUniqueUsername(storedUser.unique_username);

    const fetchPdfs = async () => {
      try {
        const response = await fetch('https://dev.invoge.com/backend/getPdfs.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: storedUser.id }),
        });

        const text = await response.text();
        console.log('Raw response:', text);
        const result = JSON.parse(text);

        if (result.status === 'success') {
          setPdfs(result.pdfs);
        } else {
          alert(result.message);
        }
      } catch (error) {
        console.error('Error fetching PDFs:', error);
      }
    };

    fetchPdfs();
  }, [navigate]);

  const handleViewPdf = (name) => {
    if (uniqueUsername) {
      navigate(`/pdf-viewer/${uniqueUsername}/${name}`);
    }
  };

  
  const handleDeletePdf = async (id) => {
    const userId = localStorage.getItem('userId'); // Retrieve userId

    if (!userId) {
      alert("User not authenticated. Please log in again.");
      navigate('/login');
      return;
    }

    try {
      const response = await fetch('https://dev.unpager.com/backend/deletePdf.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, pdf_id: id }) // Send both user_id and pdf_id
      });

      const result = await response.json();
      if (result.status === 'success') {
        alert('PDF deleted successfully');
        
        // Remove the deleted PDF from state
        setPdfs(pdfs.filter((pdf) => pdf.id !== id));

        // Update docs_count in localStorage
        const currentDocsCount = parseInt(localStorage.getItem('docs_count') || '0', 10);
        if (currentDocsCount > 0) {
          localStorage.setItem('docs_count', currentDocsCount - 1);
        }
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error('Error deleting PDF:', error);
    }
};



  const handleShowQr = (pdfName) => {
    if (uniqueUsername) {
      const pdfUrl = `https://dev.unpager.com/pdf-viewer/${uniqueUsername}/${pdfName}`;
      setQrModal({ show: true, qrUrl: pdfUrl });
    }
  };

  const handleCloseQr = () => {
    setQrModal({ show: false, qrUrl: '' });
  };

  const AnimatedButton = ({ onClick, children }) => (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
    >
      {children}
    </motion.button>
  );

  return (
    <motion.div
      className="container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1>Your Uploaded PDFs</h1>
      <ul>
        {pdfs.map((pdf) => {
          const pdfUrl = `https://dev.unpager.com/pdf-viewer/${uniqueUsername}/${pdf.name}`;
          return (
            <li key={pdf.id}>
              <span>{pdf.name}</span>
              <AnimatedButton onClick={() => handleViewPdf(pdf.name)}>View</AnimatedButton>
              <AnimatedButton onClick={() => handleShowQr(pdf.name)}>QR Code</AnimatedButton>
              <AnimatedButton onClick={() => handleDeletePdf(pdf.id)}>Delete</AnimatedButton>
            </li>
          );
        })}
      </ul>

      {/* QR Code Modal */}
      {qrModal.show && (
        <div className="modal-overlay" onClick={handleCloseQr}>
          <motion.div
            className="modal-content"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Scan to View PDF</h2>
            <QRCode value={qrModal.qrUrl} size={200} />
            <div>
                <button className="close-btn" onClick={handleCloseQr}>Close</button>
            </div>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default ProfilePage;
